<template>
  <v-list>
    <v-card-text v-if="profile">
      <v-subheader>
        Дополнительно
      </v-subheader>
      <v-list>
        <v-switch class="pl-3" label="Ночной режим" v-model="nightMode" @change="changeNightMode"></v-switch>
        <v-btn outline small color="primary" class="overflow-x-hidden" @click="requestArchive" v-if="!link">
          Архив транзакций
        </v-btn>
        <v-btn
          outline
          small
          @click="saveAs()"
          v-else
        >
          <v-icon>save</v-icon>
          <span>Сохранить на устройство</span>
        </v-btn>
      </v-list>
    </v-card-text>
    <v-progress-linear v-else indeterminate></v-progress-linear>
    <mv-page-bottom-progress v-if="inAction"></mv-page-bottom-progress>
  </v-list>
</template>

<script>
import debounce from 'debounce'
const FileSaver = require('file-saver')
const pako = require('pako')
const encoding = require('encoding')
export default {
  name: 'settings-misc',
  props: ['profile'],
  data: () => ({
    nightMode: null,
    inAction: false,
    archive: null,
    filename: null,
  }),
  computed: {
    reportsPrefix () {
      return this.$store.state.reportsPrefix
    },
    link () {
      if (!this.filename) return null
      return this.reportsPrefix + this.filename
    }
  },
  methods: {
    changeNightMode (val) {
      localStorage.setItem('detiNightMode', val)
      this.$router.go()
      // setTimeout(() => { this.$router.go() }, 500)
    },
    async fetchArchive () {
      try {
        const { filename, archive, meta } = await this.$store.dispatch('sioRequest', {
          topic: 'transfers-all-csv'
        })
        this.filename = filename
        this.archive = pako.inflate(archive, { to: 'string' })
        this.$store.dispatch('snack', meta.msg)
      } catch (err) {
        this.$store.dispatch('snack', err)
      } finally {
        this.inAction = false
      }
    },
    requestArchive () {
      this.inAction = true
      this.syncArchive()
    },
    saveAs () {
      const file = new File(
         [encoding.convert(this.archive, 'cp1251')],
         this.filename,
         { type: 'text/plain;charset=utf-8' }
       )
       FileSaver.saveAs(file)
     },
  },
  mounted () {
    this.nightMode = JSON.parse(localStorage.getItem('detiNightMode'))
  },
  created () {
    this.syncArchive = debounce(this.fetchArchive, 1000)
  }
}
</script>

<style lang="css">
</style>
